import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Group, GroupAlign, GroupGutter, GroupVerticalAlign, Icon, IconColor, IconName, IconSize, Link, LinkTarget, LinkVariant, Text, TextColor, } from '@as/cotopaxi';
import { SocialMedia } from '@as-react/common-types';
const iconDefaults = {
    size: IconSize.MEDIUM,
    spacing: { padding: 1 },
};
const alignmentDefaults = {
    align: GroupAlign.CENTER,
    valign: GroupVerticalAlign.CENTER,
};
const SocialLinks = ({ title, emphasizeTitle = false, socialMediaLinks, icon, iconColor, alignment, iconsGutter = GroupGutter.NONE, }) => {
    const filteredLinks = socialMediaLinks && socialMediaLinks.filter(({ socialLink }) => !!socialLink);
    if (!filteredLinks || filteredLinks.length === 0)
        return null;
    const socialIcon = Object.assign(Object.assign({}, iconDefaults), { color: iconColor });
    const groupAlignment = Object.assign(Object.assign({}, alignmentDefaults), alignment);
    const getIconName = (socialMedia) => {
        switch (socialMedia) {
            case SocialMedia.FACEBOOK:
                return IconName.FACEBOOK_BOX;
            case SocialMedia.INSTAGRAM:
                return IconName.INSTAGRAM;
            case SocialMedia.TWITTER:
                return IconName.TWITTER;
            case SocialMedia.LINKEDIN:
                return IconName.LINKEDIN_BOX;
            case SocialMedia.PINTEREST:
                return IconName.PINTEREST_BOX;
            case SocialMedia.YOUTUBE:
                return IconName.YOUTUBE_BOX;
            case SocialMedia.STRAVA:
                return IconName.STRAVA;
            case SocialMedia.TIKTOK:
                return IconName.TIKTOK;
            default:
                return null;
        }
    };
    const renderSocialLink = (socialLink, index) => {
        const name = getIconName(socialLink.socialName);
        if (!name) {
            return null;
        }
        return (_jsx(Link, { href: socialLink.socialLink, target: LinkTarget.BLANK, variant: LinkVariant.SUBTLE_ALT, children: _jsx(Box, { mobile: { spacing: socialIcon.spacing }, children: _jsx(Icon, { name: name, size: socialIcon.size, color: socialIcon.color === IconColor.DEFAULT ? undefined : socialIcon.color }) }) }, index));
    };
    return (_jsxs(Group, { align: groupAlignment.align, valign: groupAlignment.valign, gutter: GroupGutter.SMALL, column: true, children: [title ? (_jsx(Text, { inline: true, emphasized: emphasizeTitle, color: TextColor.INHERIT, children: title })) : null, _jsx(Group, { align: GroupAlign.CENTER, gutter: iconsGutter, children: filteredLinks.map((social, index) => renderSocialLink(social, index)) })] }));
};
export default SocialLinks;
